export default "__VITE_ASSET__DFiXsz7C__"